import React, { useState } from 'react';

import { link } from '@aline/routes';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import copy from 'copy-to-clipboard';
import { HorizontalDotsIcon } from 'src/components/icons/HorizontalDotsIcon';
import { getClientPublicOrigin, isDev } from 'src/config';
import { useDispatchSuccessSnack } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';
import { v4 as uuid4 } from 'uuid';

const useStyles = makeStyles<Pick<WorkflowCardMenuButtonProps, 'show'>>()((_, { show }) => ({
  menuButton: {
    visibility: show ? 'visible' : 'hidden',
  },
}));

interface WorkflowCardMenuButtonProps {
  show: boolean;
  workflowId: UUID;
}

export function WorkflowCardMenuButton({ show, workflowId }: WorkflowCardMenuButtonProps) {
  const { classes } = useStyles({ show });
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const dispatchLinkCopiedSnack = useDispatchSuccessSnack({
    key: uuid4(),
    message: 'Link successfully copied!',
  });

  return (
    <>
      <IconButton
        ref={setAnchorEl}
        className={classes.menuButton}
        size="small"
        onClick={e => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <HorizontalDotsIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        open={open}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        variant="menu"
        onClick={e => e.stopPropagation()}
        onClose={() => setOpen(false)}
      >
        <MenuItem
          onClick={e => {
            e.stopPropagation();
            setOpen(false);
            copy(`${getClientPublicOrigin()}${link.WorkflowDetail({ workflowId })}`, {
              debug: isDev,
            });
            dispatchLinkCopiedSnack();
          }}
        >
          <Typography variant="body1">Copy workflow link</Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
